import { FluidsConstants } from '../store/fluids.constants'

export const fluidsSchemas = [
  {
    inputKey: FluidsConstants.SET_BEFORE_INTAKE_CRYS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_BEFORE_INTAKE_CRYS: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_BEFORE_INTAKE_CRYS'],
  },
  {
    inputKey: FluidsConstants.SET_BEFORE_INTAKE_COLL,
    isNumber: true,
    type: 'object',
    properties: {
      SET_BEFORE_INTAKE_COLL: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_BEFORE_INTAKE_COLL'],
  },
  {
    inputKey: FluidsConstants.SET_BEFORE_INTAKE_OTHER,
    isNumber: true,
    type: 'object',
    properties: {
      SET_BEFORE_INTAKE_OTHER: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_BEFORE_INTAKE_OTHER'],
  },
  {
    inputKey: FluidsConstants.SET_BEFORE_INTAKE_FEEDINGS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_BEFORE_INTAKE_FEEDINGS: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_BEFORE_INTAKE_FEEDINGS'],
  },
  {
    inputKey: FluidsConstants.SET_BEFORE_OUTPUT_EBL,
    isNumber: true,
    type: 'object',
    properties: {
      SET_BEFORE_OUTPUT_EBL: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_BEFORE_OUTPUT_EBL'],
  },
  {
    inputKey: FluidsConstants.SET_BEFORE_OUTPUT_UO,
    isNumber: true,
    type: 'object',
    properties: {
      SET_BEFORE_OUTPUT_UO: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_BEFORE_OUTPUT_UO'],
  },
  {
    inputKey: FluidsConstants.SET_BEFORE_OUTPUT_OTHER,
    isNumber: true,
    type: 'object',
    properties: {
      SET_BEFORE_OUTPUT_OTHER: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_BEFORE_OUTPUT_OTHER'],
  },
  {
    inputKey: FluidsConstants.SET_DURING_INTAKE_CRYS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DURING_INTAKE_CRYS: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_DURING_INTAKE_CRYS'],
  },
  {
    inputKey: FluidsConstants.SET_DURING_INTAKE_COLL,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DURING_INTAKE_COLL: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_DURING_INTAKE_COLL'],
  },
  {
    inputKey: FluidsConstants.SET_DURING_INTAKE_OTHER,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DURING_INTAKE_OTHER: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_DURING_INTAKE_OTHER'],
  },
  {
    inputKey: FluidsConstants.SET_DURING_INTAKE_FEEDINGS,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DURING_INTAKE_FEEDINGS: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_DURING_INTAKE_FEEDINGS'],
  },
  {
    inputKey: FluidsConstants.SET_DURING_OUTPUT_EBL,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DURING_OUTPUT_EBL: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_DURING_OUTPUT_EBL'],
  },
  {
    inputKey: FluidsConstants.SET_DURING_OUTPUT_UO,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DURING_OUTPUT_UO: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_DURING_OUTPUT_UO'],
  },
  {
    inputKey: FluidsConstants.SET_DURING_OUTPUT_OTHER,
    isNumber: true,
    type: 'object',
    properties: {
      SET_DURING_OUTPUT_OTHER: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_DURING_OUTPUT_OTHER'],
  },
  {
    inputKey: FluidsConstants.SET_CUSTOM_FLUID_VALUE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_CUSTOM_FLUID_VALUE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_CUSTOM_FLUID_VALUE'],
  },
]
